var _path, _path2, _path3, _path4;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgRefreshArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24557 5.33936C3.65733 5.33936 3.99113 5.67315 3.99113 6.08492V9.81276H7.71897C8.13074 9.81276 8.46454 10.1466 8.46454 10.5583C8.46454 10.9701 8.13074 11.3039 7.71897 11.3039H3.24557C2.83381 11.3039 2.5 10.9701 2.5 10.5583V6.08492C2.5 5.67315 2.83381 5.33936 3.24557 5.33936V5.33936Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78784 4.93158C9.87303 4.4816 11.0363 4.25 12.2111 4.25C13.3858 4.25 14.5491 4.4816 15.6343 4.93158C16.7195 5.38154 17.7054 6.04103 18.5354 6.87234C18.8264 7.16372 18.8261 7.63578 18.5346 7.92673C18.2433 8.21768 17.7713 8.21733 17.4803 7.92596C16.7887 7.23335 15.9673 6.68389 15.0632 6.309C14.159 5.9341 13.1899 5.74113 12.2111 5.74113C11.2322 5.74113 10.2631 5.9341 9.35897 6.309C8.45482 6.68389 7.63347 7.23335 6.94187 7.92596L6.94071 7.92713L3.77205 11.0865C3.48046 11.3772 3.00839 11.3765 2.71766 11.0849C2.42692 10.7933 2.42762 10.3213 2.71921 10.0305L5.8867 6.87234C5.8869 6.87215 5.88709 6.87196 5.88728 6.87176C6.71726 6.04073 7.70289 5.38143 8.78784 4.93158V4.93158Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3448 13.9415C15.3448 13.5297 15.6787 13.1959 16.0904 13.1959H20.5638C20.9756 13.1959 21.3094 13.5297 21.3094 13.9415V18.4149C21.3094 18.8266 20.9756 19.1605 20.5638 19.1605C20.1521 19.1605 19.8183 18.8266 19.8183 18.4149V14.6871H16.0904C15.6787 14.6871 15.3448 14.3532 15.3448 13.9415V13.9415Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0917 13.4151C21.3825 13.7067 21.3818 14.1788 21.0901 14.4695L17.9227 17.6277C17.9225 17.6279 17.9223 17.6281 17.9221 17.6283C17.0921 18.4592 16.1065 19.1186 15.0215 19.5684C13.9364 20.0184 12.7731 20.25 11.5984 20.25C10.4236 20.25 9.26028 20.0184 8.17509 19.5684C7.08989 19.1185 6.10405 18.4589 5.27395 17.6277C4.983 17.3363 4.98335 16.8642 5.27473 16.5733C5.5661 16.2823 6.03817 16.2827 6.32912 16.5741C7.02072 17.2666 7.84208 17.8162 8.74622 18.191C9.65035 18.5659 10.6195 18.7589 11.5984 18.7589C12.5772 18.7589 13.5463 18.5659 14.4504 18.191C15.3545 17.8162 16.176 17.2666 16.8675 16.5741L16.8687 16.5729L20.0374 13.4135C20.329 13.1228 20.801 13.1235 21.0917 13.4151V13.4151Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshArrows);
export default __webpack_public_path__ + "static/media/refreshArrows.cc531e621cec79b2d3ca10427298d13c.svg";
export { ForwardRef as ReactComponent };